import * as THREE from 'three'

/**
 * Low-poly büst (site sahibi) — tools/blender/statue.py: kaide + sekizgen ayak + büst (kafa ~1.75 m), sabit,
 * kameraya (-Y) bakar. Tam boy heykel: statue.py -- full.
 * Yazı yok (uydurma metin konmaz).
 */
export default class StatueSection
{
    constructor(_options)
    {
        // Options
        this.resources = _options.resources
        this.objects = _options.objects
        this.x = _options.x
        this.y = _options.y

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.objects.add({
            base: this.resources.items.statueStaticBase.scene,
            collision: this.resources.items.statueStaticCollision.scene,
            floorShadowTexture: this.resources.items.statueStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x, this.y, 0),
            mass: 0
        })
    }
}
